/**
 * /instalar — public install CTA page (Phase 8 M8).
 *
 * Mounted as a top-level route alongside `/login`, `/reset`, `/entrar`
 * and `/verify`. The route component is intentionally thin — all the
 * platform detection + QR rendering happens inside `<InstallCTA>`.
 *
 * Why a wrapper file? TanStack file-based routing conventions plus the
 * `router.ts` registry both expect a route module export. Keeping the
 * wrapper here also lets us add SSR meta or `validateSearch` later
 * without churning the module.
 */
import { InstallCTA } from '@/modules/install'

export function InstalarPage() {
  return <InstallCTA />
}
